import React, { useState } from 'react'
import {
  Select,
  Option,
  Text,
  getSkippedItems,
  getCurrentPage,
  ListPager,
} from '@bbl-digital/snorre'
import { SelectWrapper, Wrapper } from './styles'
import { IListModel, IPaginationModel } from 'shared/models/List'

interface IProps {
  list?: IListModel | null
  filters: IPaginationModel
  listEntityName?: string
  offset?: number
  noMargin?: boolean
  hideOptions?: boolean
  term?: string
  onTakeChange: (value: number) => void
  onSkipChange: (value: number) => void
  onPageChange?: () => void
}

const Pagination: React.FC<IProps> = ({
  list,
  filters,
  listEntityName,
  offset = 150,
  noMargin,
  hideOptions,
  term = 'linjer',
  onTakeChange,
  onSkipChange,
  onPageChange,
}) => {
  const [goToPage, setGoToPage] = useState(0)
  const currentPage = getCurrentPage(filters.take, filters.skip)

  const handlePageChange = (page: number) => {
    setGoToPage(page)
    triggerPageChange(page)
  }

  const triggerPageChange = (page?: number) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    onPageChange && onPageChange()

    const skip = getSkippedItems(page || goToPage, filters.take)
    onSkipChange(skip)
    window.scrollTo(0, offset) // Scroll to top, minus all header stuff ~150px
  }

  return (
    <Wrapper noMargin={noMargin}>
      {list && list.totalCount > 0 && (
        <SelectWrapper>
          {!hideOptions && (
            <>
              <Select
                text={'Vis ' + filters.take + ' ' + term}
                onChange={(e: any) => onTakeChange(e.value)}
              >
                <Option value={10}>Vis 10 {term}</Option>
                <Option value={25}>Vis 25 {term}</Option>
                <Option value={50}>Vis 50 {term}</Option>
                <Option value={100}>Vis 100 {term}</Option>
              </Select>
              <Text data-testid="invoice-count">
                Viser {list.resultCount} av {list.totalCount}{' '}
                {listEntityName || 'resultater'}
              </Text>
            </>
          )}
        </SelectWrapper>
      )}
      {list && list.totalPageCount > 1 && (
        <ListPager
          totalPageCount={list?.totalPageCount}
          currentPage={currentPage}
          onFirstClick={() => handlePageChange(1)}
          onLastClick={handlePageChange}
          onPageClick={handlePageChange}
        />
      )}
    </Wrapper>
  )
}

export default Pagination
